<template>
  <p class="title" @click="$emit('update:title', true)">
    {{ $t('clientType.makeAppointment') }}</p>
  <div id="client_types" class="client_types">
    <div class="client_option" @click="$emit('update:clientType', 0)">
      <img src="../assets/icons/person.svg"/>
      <p class="font-bold">{{ $t('clientType.iAm') }}</p>
      <p class="text-cebeo_blue">{{ $t('clientType.customer') }}</p>
    </div>
    <div class="client_option" @click="$emit('update:clientType', 1)">
      <img src="../assets/icons/person.svg"/>
      <p class="font-bold">{{ $t('clientType.iAm') }}</p>
      <p class="text-cebeo_blue">{{ $t('clientType.professional') }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChooseClientType'
};
</script>
<style scoped>
.client_types {
  width: 520px;
  @apply flex justify-between mx-auto;
}

img {
  width: 46px;
  height: 46px;
  @apply mb-2;
}

.client_option {
  width: 254px;
  height: 254px;
  @apply bg-cebeo_blue_faded flex flex-col uppercase text-left justify-end p-5 shadow-md text-2xl cursor-pointer;
}

@media only screen and (max-width: 800px) {
  img {
    width: 23px;
    height: 23px;
  }

  .client_types {
    @apply flex flex-col w-full justify-between mx-auto;
  }

  .client_option {
    width: 95%;
    height: 75px;
    @apply bg-cebeo_blue_faded gap-x-2 mt-4 mx-auto flex flex-row uppercase text-left justify-start items-center p-5 shadow-md text-base cursor-pointer;
  }
}
</style>
